import request from "@/app/api/request";
import {
  FindUserRequestModel,
  FindUserResponse,
  UserEditedRequestModel,
  UserModelResponse,
  UserResponse
} from "./models";

export class UserRequests {
  static async getCurrentUser() {
    try {
      const res = await request.get<UserResponse>('/user/getCurrentUser', {});
      return res.user;
    } catch (error: any) {
      throw error;
    }
  }

  static async updateProfile(body: UserEditedRequestModel) {
    try {
      const res = await request.post<UserResponse>('/user/editUserProfile', {data: body});
      return res.updatedUser;
    } catch (error: any) {
      throw error;
    }
  }

  static async findUser(query: FindUserRequestModel): Promise<FindUserResponse> {
    try {
      return await request.get<FindUserResponse>('/user/findUserBySipOrNum', {query: query});
    } catch (error: any) {
      throw error;
    }
  }
}

